import './DrawerRight.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import React, { useState } from 'react';
import {
  Box, Divider, Drawer, styled, Typography,
} from '@mui/material';
import { GiHamburgerMenu } from 'react-icons/gi';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import TranslatedText from '../text/TranslatedText';
import menuRoute from '../../config/menuRoute';

function DrawerRight({ position }) {
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const MenuItem = styled(Box)(({ theme, active }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    color: active ? theme.palette.secondary.main : theme.palette.text.secondary,
    padding: '16px',
    borderRadius: '16px',
    transition: 'all 0.2s ease',
    backgroundColor: active ? theme.palette.action.hover : 'transparent',

    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.secondary.main,
      transform: 'scale(1.05)',
    },
  }));
  const isActive = (path) => location.pathname === path;
  const handleNavigate = (path) => {
    setIsOpen(false); // ferme le Drawer
    navigate(path); // navigation React Router sans recharger la page
  };
  return (
    <div className={`navbar-drawer-mobile-${position}`}>
      <div className={`hamburger-${position}`}>
        <GiHamburgerMenu
          onClick={() => setIsOpen(!isOpen)}
          size={20}
        />

      </div>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={() => setIsOpen(!isOpen)}
      >
        <Navbar>
          <Container>
            <Nav className="me-auto-mobile">
              <Box
                display="flex"
                justifyContent="center"
                flexDirection="column"
                flexWrap="wrap"
                gap={3}
                sx={{ mt: 3 }}
              >
                {menuRoute.map((item, index) => {
                  const active = isActive(item.path);
                  const { Icon } = item;
                  return (
                    <Box key={item.path}>
                      <MenuItem
                        key={item.path}
                        onClick={() => handleNavigate(item.path)}
                        active={active ? 1 : 0}
                      >
                        <Icon
                          sx={{
                            fontSize: 80,
                            mb: 1,
                            color: active ? 'theme.secondary.main' : 'theme.text.disabled',
                            transition: 'color 0.3s ease',
                          }}
                        />
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: active ? 400 : 300,
                            color: active ? 'theme.secondary.main' : 'theme.text.secondary',
                            textAlign: 'center',
                          }}
                        >
                          <TranslatedText txt={item.label} />
                        </Typography>
                      </MenuItem>
                      {index !== menuRoute.length - 1 && (
                      <Divider
                        sx={{
                          bgcolor: 'grey.600',
                          width: '80%',
                          mx: 'auto',
                          mt: 3,
                          borderBottomWidth: 1,
                        }}
                      />
                      )}
                    </Box>
                  );
                })}
              </Box>
            </Nav>
          </Container>
        </Navbar>
      </Drawer>

    </div>
  );
}

DrawerRight.propTypes = {
  position: PropTypes.string.isRequired,
};

export default DrawerRight;
